<template>
  <div>
    <v-dialog v-model="dialog" width="500" @click:outside="onCancel">
      <v-form ref="form" v-model="valid">
        <v-card>
          <v-card-title>일정구분 추가</v-card-title>
          <v-card-text>
            <v-container>
              <v-color-picker
                v-model="planType.planColHexaCd"
                disabled
                hide-canvas
                hide-inputs
                hide-mode-switch
                mode="hexa"
                :swatches="swatches"
                show-swatches
                swatches-max-height="200"
                width="500"
                class="mt-0 mb-6 mx-auto"
              >
              </v-color-picker>
              <v-text-field
                v-model="planType.planTyNm"
                label="일정구분명"
                :rules="[rules.required]"
                clearable
              ></v-text-field>
              <v-textarea
                v-model="planType.note"
                label="비고"
                clearable
              ></v-textarea>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="onCancel">취소</v-btn>
            <v-btn color="green darken-1" text @click="onSubmit">저장</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import palette from "@/util/colors";
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      dialog: true,
      valid: true,
      rules: {
        required: value => !!value || "필수 항목입니다.",
      },
      swatches: palette,
    };
  },
  computed: {
    ...mapState({
      planType: state => state.settingPlanTy.planType,
    }),
    params() {
      return this.$route.params.id;
    },
  },
  created() {
    if (this.params) {
      this.fetchData();
    }
  },
  methods: {
    ...mapActions([
      "RESET_DATA",
      "FETCH_PLANTYPE",
      "ADD_PLANTYPE",
      "EDIT_PLANTYPE",
    ]),
    reset() {
      this.$refs.form.resetValidation();
      this.RESET_DATA();
    },

    async fetchData() {
      await this.FETCH_PLANTYPE(this.params);
    },
    onCancel() {
      this.reset();
      this.$router.push("/setting/plan");
    },
    async onSubmit() {
      this.$refs.form.validate();

      if (!this.valid) return false;

      const { planColHexaCd, planTyNm, planTyNo, note } = this.planType;
      const newData = {
        planColHexaCd,
        planTyNm,
        note,
        planColNm: "",
      };

      try {
        const params = this.params;
        if (!params) {
          // 추가
          const ret = await this.ADD_PLANTYPE(newData);
          this.$emit("showResult", ret, "저장");
        } else {
          // 수정
          const ret = await this.EDIT_PLANTYPE({ planTyNo, newData });
          this.$emit("showResult", ret, "수정");
        }

        this.$router.push("/setting/plan");
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style></style>
